import python from './python.jpg';
import csharp from './csharp.jpg';
import node from './node.jpg';
import java from './java.png';
import delphi from './delphi.png';

import react from './react.png';
import javascript from './javascript.png';
import typescript from './typescript.png';
import html from './html.jpg';
import css from './css.png';

import mysql from './mysql.png';
import mongodb from './mongodb.png';
import sqlite from './sqlite.png';
import sqlserver from './sqlserver.png';
import supabase from './supabase.png';

import github from './github.png';
import visualstudio from './visualstudio.png';
import notion from './notion.png';
import figma from './figma.png';
import swagger from './swagger.png';

import tailwind from './tailwind.png';
import springboot from './springboot.png';
import dotnet from './dotnet.jpg';
import flask from './flask.jpg';
import reactnative from './react.png';
import nextjs from './nextjs.png';
import fastapi from './fastapi.png';

import windows from './windows.png';
import azure from './azure.png';
import android from './android.png';
import linux from './linux.png';
import git from './git.png';
import armbian from './armbian.png';
import vercel from './vercel.png';

export const Logos = {
    python,
    csharp,
    node,
    java,
    delphi,

    react,
    javascript,
    typescript,
    html,
    css,

    mysql,
    mongodb,
    sqlite,
    sqlserver,
    supabase,

    github,
    visualstudio,
    notion,
    figma,
    swagger,

    tailwind,
    springboot,
    dotnet,
    flask,
    reactnative,
    nextjs,
    fastapi,

    windows,
    azure,
    android,
    linux,
    git,
    armbian,
    vercel
};